import { Reducer } from 'react';
import { handleReducer } from './index';
import { IAppPage, IAppState } from 'src/interface';
import { IAppConfig, IAppRegion } from 'src/services/AppService';
import { DEVICES, OS } from 'src/constants';
import { ACTIONS } from '../actions/app/dispatchActions';

const STATE_DEFAULT: IAppState = {
    config: {
        menus: [
            {
                name: 'Nóng',
                url: '/',
            },
            {
                name: 'Mới',
                url: '/tin-moi.epi',
            },
            {
                name: 'VIDEO',
                url: '/tin-video.epi',
            },
            {
                name: 'CHỦ ĐỀ',
                url: '/chu-de.epi',
            },
        ],
        tags: [],
        categories: [],
    } as IAppConfig,
    region: {} as IAppRegion,
    page: {
        type: '',
        url: '/',
        title: 'Báo Mới - Tin tức nóng nhất, tin tức mới nhất cập nhật liên tục 24H - BAOMOI.COM',
    },
    isOnline: true,
    device: DEVICES.MOBILE,
    os: OS.ANDROID,
    isIABM: false,
    isZalo: false,
    isBot: true,
    isMiniapp: false,
    approveConsent: true,
};

const handler = {
    [ACTIONS.CONFIG_UPDATE]: (
        state: IAppState,
        config: IAppConfig
    ): IAppState => {
        let newState: IAppState = {
            ...state,
            config: {
                menus: config.menus,
                tags: config.tags,
                categories: config.categories,
            } as IAppConfig,
        };
        return newState;
    },
    [ACTIONS.PAGE_UPDATE]: (state: IAppState, page: IAppPage): IAppState => {
        return {
            ...state,
            page: Object.assign({}, page),
        };
    },
    [ACTIONS.REGION_UPDATE]: (
        state: IAppState,
        region: IAppRegion
    ): IAppState => {
        return {
            ...state,
            region,
        };
    },
    [ACTIONS.IS_ONLINE_UPDATE]: (
        state: IAppState,
        isOnline: boolean
    ): IAppState => {
        return {
            ...state,
            isOnline,
        };
    },
    [ACTIONS.DEVICE_UPDATE]: (
        state: IAppState,
        {
            device,
            os,
            isIABM,
            isZalo,
            isBot,
            isMiniapp,
        }: {
            device: DEVICES;
            os: OS;
            isIABM: boolean;
            isZalo: boolean;
            isBot: boolean;
            isMiniapp: boolean;
        }
    ): IAppState => {
        return {
            ...state,
            device,
            os,
            isIABM,
            isZalo,
            isBot,
            isMiniapp,
        };
    },
};

const appReducer: Reducer<any, any> = (state = STATE_DEFAULT, action: any) => {
    return handleReducer(handler, state, action);
};

export default appReducer;
